import React from "react";
import css from "./Topbar.module.css";

const Topbar = () => {
  return (
    <div className={css.topbar}>
      <div style={{ marginBottom: 0, padding: "8px 16px" }}>
        <span className={css.topbarText}>
          Delivery gratis por compras mayores a S/ 350.00 Cupón: DELIVERY24 |
          Ver Términos y Condiciones
        </span>
      </div>
    </div>
  );
};

export default Topbar;
